import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ExceptionManager } from "Core/logManager";
import { clientQuery, clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";

const INIT_STATE = {
  supervisor: [],
  loadingSupervisor: false,
  errorSupervisor: null,
};

const route = "modules/settings/views/driver/redux/slice";

export const driverSliceRedux = createSlice({
  name: "driver/driverFaces",
  initialState: INIT_STATE,
  reducers: {
    resetDriverFaceState: (state, action) => {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
  },
  extraReducers: (builder) => {},
});

const { actions, reducer } = driverSliceRedux;

export const { resetDriverFaceState } = actions;

export default reducer;
